import { Link } from 'react-router-dom'
import BackgroundFX from './BackgroundFX'
import { bgPhoto } from '../utils/img'
import FlowerBloom from './FlowerBloom'
import HeroScene3D from '../three/LazyHeroScene'
import './Hero.css'

const orbitEvents = [
  {
    label: 'Wedding',
    angle: 0,
    image: '/images/weddings/wedding2.webp',
    link: '/services#wedding',
  },
  {
    label: 'Corporate',
    angle: 60,
    image: '/images/corporate/corporate2.webp',
    link: '/services#corporate-events',
  },
  {
    label: 'Product Launch',
    angle: 120,
    image: '/images/product/product2.webp',
    link: '/services#product-launch',
  },
  {
    label: 'Private Party',
    angle: 180,
    image: '/images/privategatherings/privategatherings2.webp',
    link: '/services#private-party',
  },
  {
    label: 'Stage Decor',
    angle: 240,
    image: '/images/decor/decor2.webp',
    link: '/services#stage-decoration',
  },
  {
    label: 'Award Night',
    angle: 300,
    image: '/images/awards/award2.webp',
    link: '/services#cultural-award-shows',
  },
]

export default function Hero() {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${bgPhoto('/images/bg/bg3.webp', 1800, 1200)})` }}
    >

      <div className="hero-nebula-bg" aria-hidden="true">
        <div className="nebula-cloud nebula-1" />
        <div className="nebula-cloud nebula-2" />
        <div className="shooting-star" />
        <div className="shooting-star star-2" />
      </div>

      <div className="hero-scrim" />
      <FlowerBloom />
      <BackgroundFX count={25} />
      <HeroScene3D />

      <div className="container hero-inner">
        <div className="hero-copy">
          <span className="eyebrow">AS Elite Gatherings · Marthandam</span>
          <h1>
            Every Gathering,
            <br />
            <span className="text-gold hero-script">Elevated</span>
          </h1>
          <p className="hero-lede">
            <Link to="/services#corporate-events">Corporate events</Link>, <Link to="/services#product-launch">product launches</Link>, <Link to="/services#private-party">private parties</Link>, <Link to="/services#wedding">weddings</Link> and <Link to="/services#stage-decoration">stage
            decoration</Link>, <Link to="/services#cultural-award-shows">award & cultural shows</Link> — designed with intention and run without a hitch, from
            Marthandam and across Tamil Nadu.
          </p>
          <div className="hero-actions">
            <Link to="/booking" className="btn btn-primary">
              Plan Your Event
            </Link>
            <Link to="/gallery" className="btn btn-primary">
              View Our Work
            </Link>
          </div>
        </div>

        <div className="hero-orbit animate-orbit-intro" aria-hidden="true">
          <div className="orbit-ring orbit-ring-outer">
            {orbitEvents.map((e, index) => (
              <span
                key={e.label}
                className="orbit-node-pos"
                style={{ '--angle': `${e.angle}deg`, '--node-index': index }}
              >
                <Link to={e.link} className="orbit-node">
                  <div className="orbit-node-img-wrapper">
                    <img
                      src={e.image}
                      alt={e.label}
                      className="orbit-node-img"
                    />
                  </div>

                  <span className="orbit-node-label">
                    {e.label}
                  </span>
                </Link>
              </span>
            ))}
          </div>
          <div className="orbit-ring orbit-ring-inner" />
          <div className="orbit-core animate-core-intro">
            <img src="/images/logo/logo.webp" alt="AS Logo" />
          </div>
        </div>
      </div>

      <div className="hero-scroll-cue">
        <span />
        Scroll
      </div>
    </section>
  )
}